import { z } from "zod/v4";

import {
  CreateCustomEventDtoSchema,
  CustomEventDtoSchema,
} from "../../../dtos/analytics-events/custom-events";

export const PutCustomEventRequestBodySchema = z.object({
  customEvent: CreateCustomEventDtoSchema,
});

export type PutCustomEventRequestBodyType = z.infer<
  typeof PutCustomEventRequestBodySchema
>;

export const PutCustomEventResponseBodySchema = z.object({
  customEvent: CustomEventDtoSchema,
});

export type PutCustomEventResponseBodyType = z.infer<
  typeof PutCustomEventResponseBodySchema
>;
